import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          priceId: Yup.string()
                                                      .required('Required'),
                                          quantity: Yup.number()
                                                       .required('Required')
                                                       .min(1, 'Quantity must be at least 1'),
                                      });
